import React from 'react';
import { Box, Typography, Paper, useTheme } from '@mui/material';

interface WorkHoursProps {
    current: number;
    total: number;
    size?: number;
    thickness?: number;
    title?: string;
}

const WorkHoursProgress: React.FC<WorkHoursProps> = ({
    current,
    total,
    size = 160,
    thickness = 16,
    title = 'Horas trabajadas hoy'
}) => {
    const theme = useTheme();

    const percentage = Math.min(100, (current / total) * 100);

    const radius = (size - thickness) / 2;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    const completedColor = '#E6C068';
    const remainingColor = '#F2F2F2';

    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                width: 'fit-content'
            }}
        >
            <Typography variant="h6" component="h2" fontWeight="500" mb={2}>
                {title}
            </Typography>

            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: size,
                    height: size,
                }}
            >
                <svg
                    width={size}
                    height={size}
                    viewBox={`0 0 ${size} ${size}`}
                    style={{ position: 'absolute' }}
                >
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke={remainingColor}
                        strokeWidth={thickness}
                    />
                </svg>

                <svg
                    width={size}
                    height={size}
                    viewBox={`0 0 ${size} ${size}`}
                    style={{
                        position: 'absolute',
                        transform: 'rotate(-90deg)'
                    }}
                >
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke={completedColor}
                        strokeWidth={thickness}
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                        strokeLinecap="round"
                    />
                </svg>

                <Typography
                    variant="h4"
                    component="div"
                    fontWeight="bold"
                    sx={{
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {current}/{total}
                </Typography>
            </Box>
        </Paper>
    );
};

export default WorkHoursProgress;